import { prepareAndMakeRequest } from '@frontend/api';

import request from 'utils/request';

const supplierFacilities = {
  create: async (data) =>
    await request.post('/suppliers/supplier_facilities/', data),
  delete: async (supplierFacilityId) =>
    await request.delete(
      `/suppliers/supplier_facilities/${supplierFacilityId}`,
    ),
  get: async (supplierFacilityId) =>
    await request.get(`/suppliers/supplier_facilities/${supplierFacilityId}`),
  list: async () => await request.get('/suppliers/supplier_facilities/'),
  update: async (supplierFacilityId, data) =>
    await request.patch(
      `/suppliers/supplier_facilities/${supplierFacilityId}`,
      data,
    ),
  logo: {
    update: async (supplierFacilityId, formData) =>
      await request.post(
        `/suppliers/supplier_facilities/${supplierFacilityId}/logo`,
        formData,
      ),
    delete: async (logoId) =>
      await request.delete(`/suppliers/supplier_facilities/logo/${logoId}`),
  },
};

export default {
  supplierFacilities,

  addNewEmailNotificationSetting: async (data) =>
    await request.post('/suppliers/email_notification_settings', data),
  deleteEmailNotificationSetting: async (emailNotificationSettingId) =>
    await request.delete(
      `/suppliers/email_notification_settings/${emailNotificationSettingId}`,
    ),
  getDefaultEmailTemplates: async (groupId) =>
    (await request.get(`/suppliers/${groupId}/default_email_templates`)).reduce(
      (result, value) => {
        return {
          ...result,
          [value.templateType]: {
            ...value,
          },
        };
      },
      {},
    ),

  getEmailNotificationSettings: async () =>
    await request.get('/suppliers/member_email_notification_settings'),

  updateEmailNotificationSettings: async (emailNotificationSettings) =>
    await request.patch('/suppliers/member_email_notification_settings', {
      emailNotificationSettings,
    }),

  getRfqSettings: async () => await request.get(`/suppliers/rfq_settings/`),

  updateRfqSettings: async (data) =>
    await request.put(`/suppliers/rfq_settings/`, data),

  getDigiQuoteSettings: async (groupId) =>
    await request.get(`/suppliers/${groupId}/digi_quote_settings`),

  updateDigiQuoteSettings: async (groupId, data) =>
    await request.patch(`/suppliers/${groupId}/digi_quote_settings`, data),

  getAnalyticsSettings: async (groupId) =>
    await prepareAndMakeRequest.get(`/suppliers/${groupId}/analytics_settings`),

  updateAnalyticsSettings: async (groupId, data) =>
    await prepareAndMakeRequest.put(
      `/suppliers/${groupId}/analytics_settings`,
      { body: data },
    ),
};
